import { createSlice } from '@reduxjs/toolkit';

const initialStatePCovers = {
    listLoading: false,
    actionsLoading: false,
    pCovers: undefined,
    pCoversDetails: undefined,
    success: null,
    error: null,
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const pCoversSlice = createSlice({
    name: "pCovers",
    initialState: initialStatePCovers,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List PPendings
        pCoversFetched: (state, action) => {
            state.listLoading = false;
            state.pCovers = action.payload.pCovers;
            state.error = null;
        },
        // get pPendings detail
        pCoversDetailsFetched: (state, action) => {
            state.listLoading = false;
            state.pCoversDetails = action.payload.pCoversDetails;
            state.error = null;
        },
        clear: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pCoversDetails = undefined;
            state.error = null;
            state.success = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pCovers = undefined;
            state.pCoversDetails = undefined;
            state.error = null;
            state.success = null;
        }
    }
});